import React from 'react';

function CheckoutPage() {
  return (
    <div>
      <h1>Checkout Page</h1>
    </div>
  );
}

export default CheckoutPage;
